import { createLinkInterceptor } from '@mail-core/std';
import { useEffect } from 'react';
import { IGNORE_LINK_INTERCEPT_FOR_B2C_SUPERAPP } from 'reactApp/appHelpers/featuresHelpers/features/mailSuperapp';
import { WorkspaceSuperAppService } from 'reactApp/services';
import { navigationRef } from 'reactApp/ui/App/components/NavigationSetter';

const useWorkspaceSuperappNavigation = () => {
    useEffect(() => {
        if (WorkspaceSuperAppService.isEnabled) {
            return createLinkInterceptor(
                (data) => {
                    if (data.url === 'about:blank') {
                        return null;
                    }

                    const url = new URL(data.url, window.location.origin);

                    if (url.origin !== window.location.origin) {
                        WorkspaceSuperAppService.openLink(url.href);
                    } else {
                        // data.url - относительный путь

                        switch (data.type) {
                            case 'click':
                            case 'keydown':
                                if (navigationRef.current) {
                                    navigationRef.current(url.pathname);
                                } else {
                                    window.location.href = url.href;
                                }
                                break;
                            case 'window.open':
                                WorkspaceSuperAppService.openLink(url.href);
                        }
                    }

                    return null;
                },
                {
                    // Ссылка на промо-страницу десктопного приложения должна открываться
                    // в новом окне через стандартный window.open, а не через OpenLink бридж,
                    // чтобы пользователь мог скачать приложение.
                    ignore: WorkspaceSuperAppService.isB2CMode ? IGNORE_LINK_INTERCEPT_FOR_B2C_SUPERAPP : [],
                }
            );
        }
    }, []);
};

export default useWorkspaceSuperappNavigation;
